import { render, staticRenderFns } from "./materTransfer.vue?vue&type=template&id=1e627aef&"
import script from "./materTransfer.vue?vue&type=script&lang=js&"
export * from "./materTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports